module.exports = __webpack_public_path__ + "static/img/all_pharmacy.ffe55a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/all_pharmacy.jpg
// module id = 16
// module chunks = 0